import { Box, Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/components/Text";
import { type ReactNode } from "react";

function getIsMac(): boolean {
  return navigator.platform.toUpperCase().includes("MAC");
}

export function getShortcutHint(): string {
  return getIsMac() ? "⌘K" : "Ctrl+K";
}

function getCopyShortcutHint(): string {
  return getIsMac() ? "⌘C" : "Ctrl+C";
}

function Kbd(props: { children: ReactNode }) {
  return (
    <Box
      component="span"
      sx={(theme) => ({
        display: "inline-flex",
        alignItems: "center",
        paddingX: 1,
        paddingY: "1px",
        minWidth: "1.25rem",
        justifyContent: "center",
        backgroundColor: theme.palette.action.hover,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.borderRadius?.xSmall,
        fontFamily: "monospace",
        fontSize: "0.7rem",
        lineHeight: 1.4,
        color: theme.palette.text.primary,
      })}
    >
      {props.children}
    </Box>
  );
}

function Hint(props: { keys: ReactNode; label: string }) {
  return (
    <Stack direction="row" sx={{ alignItems: "center", gap: 2 }}>
      {props.keys}
      <Text color="text.secondary" variant="caption">
        {props.label}
      </Text>
    </Stack>
  );
}

export function KeyboardHints() {
  return (
    <>
      <Hint
        keys={
          <>
            <Kbd>↑</Kbd>
            <Kbd>↓</Kbd>
          </>
        }
        label="Navigate"
      />
      <Hint keys={<Kbd>⏎</Kbd>} label="Select" />
      <Hint keys={<Kbd>{getCopyShortcutHint()}</Kbd>} label="Copy ID" />
      <Hint keys={<Kbd>Esc</Kbd>} label="Close" />
    </>
  );
}
